export const secondsToDate = (seconds) => new Date(seconds * 1000).toISOString().substr(14, 5);
//# sourceMappingURL=helpers.js.map